import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarComponent } from '../calendar/calendar.component';
import { CommonModule } from '@angular/common';
import { PrimeNGModule } from '../../modules/primeng.module';

@Component({
  imports: [CommonModule, CalendarComponent, PrimeNGModule],
  selector: 'app-slot-booking',
  templateUrl: './slot-booking.component.html',
  styleUrls: ['./slot-booking.component.scss']
})
export class SlotBookingComponent implements OnInit {
  @Input() availableDates: any;
  @Input() selectedSlot: any;
  @Input() hideTimes: boolean = false;
  @Output() slotSelected = new EventEmitter<any>();

  selectedDate: any;

  ngOnInit() {
    // Pre-select the date that matches the incoming selectedSlot
    if (this.selectedSlot && this.availableDates?.length > 0) {
      this.selectedDate = this.availableDates.find(d => d.date === this.selectedSlot.date) ?? null
    }
  }

  onDateSelected(date: any) {
    this.selectedDate = date;
    if (this.hideTimes) {
      this.slotSelected.emit(date)
    }
  }

  onSlotSelected(slot: any) {
    this.slotSelected.emit(slot)
  }
}